<template>
  <div class="content-dashboard">
    <template v-if="mode === 'simple'">
      <div class="row mb-5 mt-4">
        <div class="col-lg-12">
          <div class="d-flex align-items-center justify-content-between">
            <h3>Mes adresses de clinique(s)</h3>

            <p class="mb-0">
              Pour tout ajout, modification ou suppression d'adresse de clinique, merci de
              <a href="#" class="blue-link" @click="mode = 'modifier'">nous contacter</a>
            </p>
          </div>
        </div>
      </div>

      <div class="row mb-5 mt-4">
        <div class="col-lg-12">
          <div class="gray-box flex-column">
            <div
              v-for="(adress, index) in ListAddressesLivraison"
              :key="index"
              class="adress-item d-flex justify-content-between w-100 align-items-center"
            >
              <p class="mb-0">
                <i class="ti ti-location-pin blue-color"></i>
                {{ adress.firstName }} {{ adress.lastName }} - {{ adress.street }}, {{ adress.postcode }}
                {{ adress.city }}
              </p>
              <div class="d-flex gap-2">
                <a href="#" class="btn btn-orange btn-circle" @click="openModificationClinique(adress)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18.5" height="18.5" viewBox="0 0 18.5 18.5">
                    <g id="edit" transform="translate(-3.25 -2.25)">
                      <path
                        id="Tracé_13934"
                        data-name="Tracé 13934"
                        d="M16.475,5.408l2.117,2.117m-.756-3.982L12.109,9.27a2.118,2.118,0,0,0-.579,1.082L11,13l2.648-.53a2.118,2.118,0,0,0,1.082-.579l5.727-5.727a1.854,1.854,0,0,0-2.621-2.621Z"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                      ></path>
                      <path
                        id="Tracé_13935"
                        data-name="Tracé 13935"
                        d="M19,15v3a2,2,0,0,1-2,2H6a2,2,0,0,1-2-2V7A2,2,0,0,1,6,5H9"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                      ></path>
                    </g>
                  </svg>
                </a>
                <a href="#" class="btn btn-orange btn-circle" @click="openSuppressionClinique(adress)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="17.5" height="19.5" viewBox="0 0 17.5 19.5">
                    <g id="delete-svgrepo-com_2_" data-name="delete-svgrepo-com (2)" transform="translate(0.75 0.75)">
                      <path
                        id="Tracé_5768"
                        data-name="Tracé 5768"
                        d="M10,11v6"
                        transform="translate(-4 -3)"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                      ></path>
                      <path
                        id="Tracé_5769"
                        data-name="Tracé 5769"
                        d="M14,11v6"
                        transform="translate(-4 -3)"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                      ></path>
                      <path
                        id="Tracé_5770"
                        data-name="Tracé 5770"
                        d="M4,7H20"
                        transform="translate(-4 -3)"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                      ></path>
                      <path
                        id="Tracé_5771"
                        data-name="Tracé 5771"
                        d="M6,7H18V18a3,3,0,0,1-3,3H9a3,3,0,0,1-3-3Z"
                        transform="translate(-4 -3)"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                      ></path>
                      <path
                        id="Tracé_5772"
                        data-name="Tracé 5772"
                        d="M9,5a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2V7H9Z"
                        transform="translate(-4 -3)"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                      ></path>
                    </g>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <h3>Les adresses de mes clients</h3>

      <div class="row mb-5 mt-4">
        <div class="col-lg-12">
          <div class="gray-box flex-column">
            <div class="d-flex justify-content-between w-100 mb-4">
              <div class="left-adress-item d-flex gap-3 align-items-center w-65">
                <div class="search-block w-50">
                  <form>
                    <input
                      type="text"
                      class="form-control"
                      v-model="searchAdressClient"
                      id="search"
                      placeholder="rechercher un proprietaire "
                    />
                    <button class="search-btn">
                      <i class="ti ti-search"></i>
                    </button>
                  </form>
                </div>
              </div>

              <div class="right-adress-item">
                <a href="#" class="btn btn-orange" @click.prevent="OpenAddNewAdressModal">
                  <img :src="plus" class="icon-plus" /> une nouvelle adresse</a
                >
              </div>
            </div>

            <div
              v-for="adress in paginatedAddressesClients"
              :key="adress.id"
              class="adress-item d-flex justify-content-between w-100 align-items-center"
            >
              <p class="mb-0">
                <i class="ti ti-location-pin blue-color"></i>
                {{ adress.firstName }} {{ adress.lastName }} - {{ adress.street }}, {{ adress.postcode }}
                {{ adress.city }}
              </p>

              <div class="d-flex gap-2">
                <a href="#" class="btn btn-orange btn-circle" @click.prevent="OpenModifAdressModal(adress)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18.5" height="18.5" viewBox="0 0 18.5 18.5">
                    <g id="edit" transform="translate(-3.25 -2.25)">
                      <path
                        id="Tracé_13934"
                        data-name="Tracé 13934"
                        d="M16.475,5.408l2.117,2.117m-.756-3.982L12.109,9.27a2.118,2.118,0,0,0-.579,1.082L11,13l2.648-.53a2.118,2.118,0,0,0,1.082-.579l5.727-5.727a1.854,1.854,0,0,0-2.621-2.621Z"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                      ></path>
                      <path
                        id="Tracé_13935"
                        data-name="Tracé 13935"
                        d="M19,15v3a2,2,0,0,1-2,2H6a2,2,0,0,1-2-2V7A2,2,0,0,1,6,5H9"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                      ></path>
                    </g>
                  </svg>
                </a>
                <a href="#" class="btn btn-orange btn-circle" @click.prevent="OpenRemoveAdressModal(adress.id)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="17.5" height="19.5" viewBox="0 0 17.5 19.5">
                    <g id="delete-svgrepo-com_2_" data-name="delete-svgrepo-com (2)" transform="translate(0.75 0.75)">
                      <path
                        id="Tracé_5768"
                        data-name="Tracé 5768"
                        d="M10,11v6"
                        transform="translate(-4 -3)"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                      ></path>
                      <path
                        id="Tracé_5769"
                        data-name="Tracé 5769"
                        d="M14,11v6"
                        transform="translate(-4 -3)"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                      ></path>
                      <path
                        id="Tracé_5770"
                        data-name="Tracé 5770"
                        d="M4,7H20"
                        transform="translate(-4 -3)"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                      ></path>
                      <path
                        id="Tracé_5771"
                        data-name="Tracé 5771"
                        d="M6,7H18V18a3,3,0,0,1-3,3H9a3,3,0,0,1-3-3Z"
                        transform="translate(-4 -3)"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                      ></path>
                      <path
                        id="Tracé_5772"
                        data-name="Tracé 5772"
                        d="M9,5a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2V7H9Z"
                        transform="translate(-4 -3)"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                      ></path>
                    </g>
                  </svg>
                </a>
              </div>
            </div>

            <div
              v-if="ListAddressesClients.length > itemsPerPage"
              class="pagination mt-4 d-flex justify-content-center align-items-center"
            >
              <button @click="previousPage" :disabled="currentPage === 1" class="pagination-btn prev">
                <i class="ti ti-angle-left"></i>
              </button>
              <div class="pagination-content">
                <div class="pagination-btns mt-4">
                  <button
                    v-for="page in totalPages"
                    :key="page"
                    @click="goToPage(page)"
                    :class="['pagination-btn-numbers', { active: currentPage === page }]"
                    class="mx-1"
                  >
                    {{ page }}
                  </button>
                </div>
                <span class="pagination-info">Sur {{ totalPages }}</span>
              </div>

              <button @click="nextPage" :disabled="currentPage === totalPages" class="pagination-btn next">
                <i class="ti ti-angle-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="d-flex gap-2 align-items-center">
        <span class="back-link cursor-pointer" @click="retourModeSimple">
          <i class="ti ti-back-left font-20 orange-color pe-2"></i>
        </span>
        <h3 v-if="modeClinique === 'modification'">Modification d'une adresse clinique</h3>
        <h3 v-else-if="modeClinique === 'suppression'">Suppression d'une adresse clinique</h3>
        <h3 v-else>Mes adresses de clinique</h3>
      </div>

      <div v-if="modeClinique === 'suppression' && adresseCliniqueSelectionnee" class="alert alert-warning mt-3">
        <p>
          <strong>Attention :</strong> Vous êtes sur le point de demander la suppression d'une adresse clinique. Cette
          action nécessite une validation de notre part.
        </p>
        <p class="mb-0">
          <strong>Adresse concernée :</strong> {{ adresseCliniqueSelectionnee.firstName }}
          {{ adresseCliniqueSelectionnee.lastName }} - {{ adresseCliniqueSelectionnee.street }},
          {{ adresseCliniqueSelectionnee.postcode }} {{ adresseCliniqueSelectionnee.city }}
        </p>
      </div>

      <div v-if="modeClinique === 'modification'" class="check-element mt-4">
        <h4 class="font-16 blue-color mb-3">Sélectionnez les éléments que vous souhaitez modifier :</h4>

        <div class="d-flex gap-4">
          <div class="custom-checkbox">
            <label> <input type="checkbox" v-model="form.update_billing_address" /> Adresse de facturation</label>
          </div>
          <div class="custom-checkbox">
            <label> <input type="checkbox" v-model="form.update_delivery_address" /> Adresse de livraison</label>
          </div>
        </div>
      </div>

      <div class="form-block">
        <div class="row">
          <div class="col-lg-6">
            <div class="form-input">
              <label class="label-control">Sujet :</label>
              <input type="text" class="form-control" v-model="form.sujet" disabled />
            </div>
          </div>
        </div>

        <div v-if="form.update_billing_address && modeClinique === 'modification'">
          <h5 class="blue-color font-bold font-16 mt-5 mb-4">Adresse de facturation</h5>

          <div class="row">
            <div class="col-lg-6">
              <div class="form-input">
                <label class="label-control">Adresse* :</label>
                <input type="text" class="form-control" v-model="form.update_billing_address_address" />
                <span v-if="errorDemandeAdressFacturation" class="error-message mb-1">{{
                  errorDemandeAdressFacturation
                }}</span>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="form-input">
                <label class="label-control">Complément d'adresse :</label>
                <input type="text" class="form-control" v-model="form.update_billing_address_address2" />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6">
              <div class="form-input">
                <label class="label-control">Complément d'adresse 2 :</label>
                <input type="text" class="form-control" v-model="form.update_billing_address_address3" />
              </div>
            </div>

            <div class="col-lg-6">
              <div class="form-input">
                <label class="label-control">Code postal* :</label>
                <input type="text" class="form-control" v-model="form.update_billing_address_postcode" v-only-digits />
                <span v-if="errorDemandeCodePostalFacturation" class="error-message mb-1">{{
                  errorDemandeCodePostalFacturation
                }}</span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6">
              <div class="form-input">
                <label class="label-control">Ville* :</label>
                <input type="text" class="form-control" v-model="form.update_billing_address_city" />
                <span v-if="errorDemandeVilleFacturation" class="error-message mb-1">{{
                  errorDemandeVilleFacturation
                }}</span>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="form-input">
                <label class="label-control">Pays* :</label>
                <input type="text" class="form-control" v-model="form.update_billing_address_pays" />
                <span v-if="errorDemandePaysFacturation" class="error-message mb-1">{{
                  errorDemandePaysFacturation
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <div v-if="form.update_delivery_address && modeClinique === 'modification'">
          <h5 class="blue-color font-bold font-16 mt-5 mb-4">Adresse de livraison</h5>

          <div class="row">
            <div class="col-lg-6">
              <div class="form-input">
                <label class="label-control">Adresse* :</label>
                <input type="text" class="form-control" v-model="form.update_delivery_address_address" />
                <span v-if="errorDemandeAdressLivraison" class="error-message mb-1">{{
                  errorDemandeAdressLivraison
                }}</span>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="form-input">
                <label class="label-control">Complément d'adresse :</label>
                <input type="text" class="form-control" v-model="form.update_delivery_address_address2" />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6">
              <div class="form-input">
                <label class="label-control">Complément d'adresse 2 :</label>
                <input type="text" class="form-control" v-model="form.update_delivery_address_address3" />
              </div>
            </div>

            <div class="col-lg-6">
              <div class="form-input">
                <label class="label-control">Code postal* :</label>
                <input type="text" class="form-control" v-model="form.update_delivery_address_postcode" v-only-digits />
                <span v-if="errorDemandeCodePostalLivraison" class="error-message mb-1">{{
                  errorDemandeCodePostalLivraison
                }}</span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6">
              <div class="form-input">
                <label class="label-control">Ville* :</label>
                <input type="text" class="form-control" v-model="form.update_delivery_address_city" />
                <span v-if="errorDemandeVilleLivraison" class="error-message mb-1">{{
                  errorDemandeVilleLivraison
                }}</span>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="form-input">
                <label class="label-control">Pays* :</label>
                <input type="text" class="form-control" v-model="form.update_delivery_address_pays" />
                <span v-if="errorDemandePaysLivraison" class="error-message mb-1">{{ errorDemandePaysLivraison }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-lg-12">
            <div class="form-input">
              <label class="label-control">Message* :</label>
              <textarea class="form-control round-15" rows="7" v-model="form.message"></textarea>
              <span v-if="errorDemandeMessage" class="error-message mb-1">{{ errorDemandeMessage }}</span>
            </div>
          </div>
        </div>

        <div class="row justify-content-center mt-4">
          <div class="col-lg-4">
            <button @click="EnvoiDemandeUpdate" class="btn btn-orange w-100" id="send-demande">
              {{ modeClinique === "suppression" ? "Confirmer la suppression" : "Enregistrer" }}
            </button>
          </div>
        </div>
        <div v-if="successEnvoiDemandeMessage" class="alert alert-success mt-4 w-50 content-centered">
          <span class="success-message">{{ successEnvoiDemandeMessage }}</span>
        </div>
      </div>
    </template>

    <div
      class="modal fade"
      id="adressclient"
      ref="adressclient"
      tabindex="-1"
      aria-labelledby="modalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-width">
        <div class="modal-content">
          <div class="modal-header justify-content-end">
            <button type="button" class="close-link" data-bs-dismiss="modal" aria-label="Fermer">
              <i class="ti ti-close"></i>
            </button>
          </div>
          <div class="modal-body padd-modal">
            <h3 v-if="!HasEdit">Ajout d'une nouvel adresse client</h3>
            <h3 v-else>Modification d'une adresse client</h3>

            <form class="mt-4">
              <div class="d-flex gap-3">
                <div class="input-form">
                  <label class="label-control">Nom*</label>
                  <input type="text" class="form-control" v-model="clientadress.lastName" />
                  <span v-if="erroradressLastName" class="error-message mb-1">{{ erroradressLastName }}</span>
                </div>
                <div class="input-form">
                  <label class="label-control">Prénom*</label>
                  <input type="text" class="form-control" v-model="clientadress.firstName" />
                  <span v-if="erroradressFirstName" class="error-message mb-1">{{ erroradressFirstName }}</span>
                </div>
              </div>

              <div class="d-flex gap-3">
                <div class="input-form" style="flex: 1">
                  <label class="label-control">Société</label>
                  <input type="text" class="form-control" v-model="clientadress.company" />
                </div>
              </div>

              <div class="d-flex gap-3">
                <div class="input-form">
                  <label class="label-control">Adresse*</label>
                  <input type="text" class="form-control" v-model="clientadress.street" />
                  <span v-if="erroradressStreet" class="error-message mb-1">{{ erroradressStreet }}</span>
                </div>
                <div class="input-form">
                  <label class="label-control">Code postal</label>
                  <input type="text" class="form-control" v-model="clientadress.postcode" v-only-digits />
                  <span v-if="erroradressCodePostal" class="error-message mb-1">{{ erroradressCodePostal }}</span>
                </div>
              </div>

              <div class="d-flex gap-3">
                <div class="input-form">
                  <label class="label-control">Ville</label>
                  <input type="text" class="form-control" v-model="clientadress.city" />
                  <span v-if="erroradressVille" class="error-message mb-1">{{ erroradressVille }}</span>
                </div>
                <div class="input-form client-pays">
                  <label class="label-control">Pays</label>
                  <div class="dropdown w-100 mb-2">
                    <button
                      class="form-control dropdown-toggle w-100 text-start"
                      :class="{ error: erroradressPays }"
                      type="button"
                      @click="toggleDropdownCountry"
                    >
                      {{ selectedCountry.name || "Sélectionner un pays" }}
                    </button>

                    <div
                      class="dropdown-menu show w-100 p-2"
                      v-if="isOpenCountry"
                      style="max-height: 300px; overflow-y: auto"
                    >
                      <input
                        type="text"
                        class="form-control mb-2"
                        placeholder="Rechercher un pays..."
                        v-model="searchCountry"
                        @click.stop
                      />

                      <button
                        v-for="country in filteredCountries"
                        :key="country.code"
                        class="dropdown-item text-start"
                        @click="selectCountry(country)"
                      >
                        {{ country.name }}
                        <span v-if="selectedCountry.code === country.code" class="ms-2 text-success">✔</span>
                      </button>
                    </div>
                  </div>
                  <span v-if="erroradressPays" class="error-message mb-1">{{ erroradressPays }}</span>
                </div>
              </div>

              <div class="d-flex gap-3">
                <div class="input-form">
                  <label class="label-control">Email*</label>
                  <input type="email" class="form-control" v-model="clientadress.email" />
                  <small class="text-muted d-block mt-1">Utilisée pour les notifications de suivi du colis</small>
                  <span v-if="erroradressEmail" class="error-message mb-1">{{ erroradressEmail }}</span>
                </div>
                <div class="input-form">
                  <label class="label-control">Téléphone*</label>
                  <input type="tel" class="form-control" v-model="clientadress.cellphone" v-only-digits />
                  <span v-if="erroradressCellphone" class="error-message mb-1">{{ erroradressCellphone }}</span>
                </div>
              </div>

              <div class="d-flex justify-content-center">
                <button
                  v-if="!HasEdit"
                  class="btn btn-orange"
                  id="save-client-adress"
                  @click.prevent="AddNewAdressClient"
                >
                  Enregistrer
                </button>
                <button v-else class="btn btn-orange" id="save-client-adress" @click.prevent="ModifAdressClient">
                  Modifier
                </button>
              </div>
              <div v-if="successadressMessage" class="alert alert-success mt-4 w-50 content-centered">
                <span class="success-message">{{ successadressMessage }}</span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="RemoveAdress"
      ref="RemoveAdress"
      tabindex="-1"
      aria-labelledby="modalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-width">
        <div class="modal-content">
          <div class="modal-header justify-content-end">
            <button type="button" class="close-link" data-bs-dismiss="modal" aria-label="Fermer">
              <i class="ti ti-close"></i>
            </button>
          </div>
          <div class="modal-body padd-modal">
            <h3>Suppression d'une adresse client</h3>

            <form class="mt-4">
              <p class="label-control text-center">
                Êtes-vous sûr de vouloir supprimer cette adresse du client ? Cette action est irréversible.
              </p>
              <div class="d-flex justify-content-center">
                <button class="btn btn-orange" id="remove-adress" @click.prevent="RemoveAdressClient">Confirmer</button>
              </div>
              <div v-if="successDeleteadressMessage" class="alert alert-success mt-4 w-50 content-centered">
                <span class="success-message">{{ successDeleteadressMessage }}</span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import plus from "@/assets/images/plus-circle.svg";
  import { useRegisterStore } from "@/stores/register";
  import { getAddresses } from "@/api/services/esupplyvet/addressesService";
  import {
    UpdateInfosPersonnelles,
    CreateNewAdressClient,
    UpdateAdressClient,
    getCountries,
    DeleteAdressClient,
  } from "@/api/auth";
  import "bootstrap/dist/js/bootstrap.bundle.min.js";
  import { Modal } from "bootstrap";
  import $ from "jquery";
  import { useDelegueStore } from "@/stores/delegueStore";

  export default {
    name: "AdresseLivraisonView",

    data() {
      return {
        plus,
        addressList: [],
        registerStore: null,
        searchAdressClient: "",
        selectedCountry: "",
        isOpenCountry: false,
        searchCountry: "",
        countries: [],
        HasEdit: false,
        clientadress: {
          divalto_id: "",
          firstName: "",
          lastName: "",
          company: "",
          street: "",
          postcode: "",
          city: "",
          countryCode: "",
          email: "",
          cellphone: "",
        },
        erroradressLastName: "",
        erroradressFirstName: "",
        erroradressStreet: "",
        erroradressCodePostal: "",
        erroradressVille: "",
        erroradressPays: "",
        erroradressEmail: "",
        erroradressCellphone: "",
        canStoreClientadress: true,
        isLoadingClientadress: false,
        successadressMessage: "",
        adressToRemove: null,
        successDeleteadressMessage: "",
        mode: "simple",
        modeClinique: "simple", // 'simple', 'modification', 'suppression'
        adresseCliniqueSelectionnee: null,
        form: {
          sujet: "Demande de Modification/suppression d’une adresse",
          sujet_form: "modifadresse",
          message: "",
          channel: "/api/v2/shop/channels/supplyvet",

          update_billing_address: false,
          update_delivery_address: false,

          update_billing_address_address: "",
          update_billing_address_address2: "",
          update_billing_address_address3: "",
          update_billing_address_postcode: "",
          update_billing_address_city: "",
          update_billing_address_pays: "",

          update_delivery_address_address: "",
          update_delivery_address_address2: "",
          update_delivery_address_address3: "",
          update_delivery_address_postcode: "",
          update_delivery_address_city: "",
          update_delivery_address_pays: "",
        },
        errorDemandeAdressFacturation: "",
        errorDemandeCodePostalFacturation: "",
        errorDemandeVilleFacturation: "",
        errorDemandePaysFacturation: "",
        errorDemandeAdressLivraison: "",
        errorDemandeCodePostalLivraison: "",
        errorDemandeVilleLivraison: "",
        errorDemandePaysLivraison: "",
        errorDemandeMessage: "",
        canStoreDemande: true,
        isLoadingDemande: false,
        successEnvoiDemandeMessage: "",
        currentPage: 1,
        itemsPerPage: 4,
      };
    },
    computed: {
      ListAddressesLivraison() {
        return this.addressList.filter(adr => adr.veterinary);
      },
      ListAddressesClients() {
        let data = this.addressList.filter(adr => !adr.veterinary);

        if (this.searchAdressClient !== "") {
          data = data.filter(
            adr =>
              (adr.firstName + " " + adr.lastName)?.toLowerCase().includes(this.searchAdressClient.toLowerCase()) ||
              adr.street?.toLowerCase().includes(this.searchAdressClient.toLowerCase()) ||
              adr.postcode?.toLowerCase().includes(this.searchAdressClient.toLowerCase()) ||
              adr.city?.toLowerCase().includes(this.searchAdressClient.toLowerCase())
          );
        }
        return data;
      },
      filteredCountries() {
        const query = this.searchCountry.toLowerCase();
        return this.countries.filter(country => country.name.toLowerCase().includes(query));
      },

      paginatedAddressesClients() {
        const start = (this.currentPage - 1) * this.itemsPerPage;
        const end = start + this.itemsPerPage;
        return this.ListAddressesClients.slice(start, end);
      },
      totalPages() {
        return Math.ceil(this.ListAddressesClients.length / this.itemsPerPage);
      },

      userRole() {
        return this.registerStore.user?.role;
      },

      selectedVetForDelegue() {
        const delegueStore = useDelegueStore();
        return delegueStore.selectedVeterinarian;
      },
    },
    created() {
      this.registerStore = useRegisterStore();
      this.fetchAddresses();
    },
    mounted() {
      this.GetPays();
    },
    methods: {
      fetchAddresses() {
        getAddresses()
          .then(response => {
            this.addressList = response.data;
          })
          .catch(error => {
            console.error("Erreur lors de la récupération des adresses:", error);
          });
      },

      /*************************Gestion des modes clinique****************************/
      openModificationClinique(adresse) {
        this.modeClinique = "modification";
        this.adresseCliniqueSelectionnee = adresse;
        this.mode = "modifier";
        this.preRemplirFormulaireClinique(adresse);
      },

      openSuppressionClinique(adresse) {
        this.modeClinique = "suppression";
        this.adresseCliniqueSelectionnee = adresse;
        this.mode = "modifier";
        this.form.sujet_form = "modifadresse";

        this.form.message = `Je souhaite supprimer l'adresse suivante : ${adresse.firstName} ${adresse.lastName} - ${adresse.street}, ${adresse.postcode} ${adresse.city}`;
      },

      preRemplirFormulaireClinique(adresse) {
        this.form.update_billing_address_address = adresse.street || "";
        this.form.update_billing_address_postcode = adresse.postcode || "";
        this.form.update_billing_address_city = adresse.city || "";
        this.form.update_billing_address_pays = this.getCountryName(adresse.countryCode) || "";

        this.form.message = `Je souhaite modifier l'adresse suivante : ${adresse.firstName} ${adresse.lastName} - ${adresse.street}, ${adresse.postcode} ${adresse.city}`;
      },

      getCountryName(countryCode) {
        const country = this.countries.find(c => c.code === countryCode);
        return country ? country.name : "";
      },

      retourModeSimple() {
        this.mode = "simple";
        this.modeClinique = "simple";
        this.adresseCliniqueSelectionnee = null;
        this.ResetFormDemande();
      },

      /*************************Demande modification/suppression adresse****************************/
      EnvoiDemandeUpdate() {
        this.errorDemandeAdressFacturation = "";
        this.errorDemandeCodePostalFacturation = "";
        this.errorDemandeVilleFacturation = "";
        this.errorDemandePaysFacturation = "";
        this.errorDemandeAdressLivraison = "";
        this.errorDemandeCodePostalLivraison = "";
        this.errorDemandeVilleLivraison = "";
        this.errorDemandePaysLivraison = "";
        this.errorDemandeMessage = "";
        this.canStoreDemande = true;
        this.isLoadingDemande = true;

        var spinner =
          '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Envoi demande en cours ...';
        $("#send-demande").html(spinner);

        this.CheckValidateDemande();

        if (this.canStoreDemande) {
          const donneesDemande = { ...this.form };

          // Ajouter l'action et l'ID d'adresse pour les demandes clinique
          if (this.adresseCliniqueSelectionnee) {
            if (this.modeClinique === "modification") {
              donneesDemande.action = "modification_adresse";
              donneesDemande.adresse_id = this.adresseCliniqueSelectionnee.id;
            } else if (this.modeClinique === "suppression") {
              donneesDemande.action = "suppression_adresse";
              donneesDemande.adresse_id = this.adresseCliniqueSelectionnee.id;
            }
          }

          UpdateInfosPersonnelles(donneesDemande)
            .then(res => {
              if (res.data && res.data.send) {
                this.ResetFormDemande();
                this.successEnvoiDemandeMessage = "Votre demande a été envoyée avec succès";
                setTimeout(() => {
                  this.successEnvoiDemandeMessage = "";
                  this.retourModeSimple();
                }, 5000);
              }
              $("#send-demande").text(this.modeClinique === "suppression" ? "Confirmer la suppression" : "Enregistrer");
              this.isLoadingDemande = false;
            })
            .catch(() => {
              this.isLoadingDemande = false;
              $("#send-demande").text(this.modeClinique === "suppression" ? "Confirmer la suppression" : "Enregistrer");
            });
        }
      },

      CheckValidateDemande() {
        if (this.form.update_billing_address && this.modeClinique === "modification") {
          if (this.form.update_billing_address_address == "") {
            this.errorDemandeAdressFacturation = "Le champ addresse de facturation est obligatoire";
            this.canStoreDemande = false;
          }
          if (this.form.update_billing_address_postcode == "") {
            this.errorDemandeCodePostalFacturation = "Le champ Code postal de facturation est obligatoire";
            this.canStoreDemande = false;
          }
          if (this.form.update_billing_address_city == "") {
            this.errorDemandeVilleFacturation = "Le champ ville de facturation est obligatoire";
            this.canStoreDemande = false;
          }
          if (this.form.update_billing_address_pays == "") {
            this.errorDemandePaysFacturation = "Le champ pays de facturation est obligatoire";
            this.canStoreDemande = false;
          }
        }

        if (this.form.update_delivery_address && this.modeClinique === "modification") {
          if (this.form.update_delivery_address_address == "") {
            this.errorDemandeAdressLivraison = "Le champ addresse de livraison est obligatoire";
            this.canStoreDemande = false;
          }
          if (this.form.update_delivery_address_postcode == "") {
            this.errorDemandeCodePostalLivraison = "Le champ Code postal de livraison est obligatoire";
            this.canStoreDemande = false;
          }
          if (this.form.update_delivery_address_city == "") {
            this.errorDemandeVilleLivraison = "Le champ ville de livraison est obligatoire";
            this.canStoreDemande = false;
          }
          if (this.form.update_delivery_address_pays == "") {
            this.errorDemandePaysLivraison = "Le champ pays de livraison est obligatoire";
            this.canStoreDemande = false;
          }
        }

        if (this.form.message == "") {
          this.errorDemandeMessage = "Le champ message est obligatoire";
          this.canStoreDemande = false;
        }

        if (!this.canStoreDemande) {
          this.isLoadingDemande = false;
          $("#send-demande").text(this.modeClinique === "suppression" ? "Confirmer la suppression" : "Enregistrer");
        }
      },

      ResetFormDemande() {
        this.form = {
          sujet: "Demande de Modification/suppression d'une adresse",
          message: "",
          channel: "/api/v2/shop/channels/supplyvet",
          sujet_form: "modifadresse",

          update_billing_address: false,
          update_delivery_address: false,

          update_billing_address_address: "",
          update_billing_address_address2: "",
          update_billing_address_address3: "",
          update_billing_address_postcode: "",
          update_billing_address_city: "",
          update_billing_address_pays: "",

          update_delivery_address_address: "",
          update_delivery_address_address2: "",
          update_delivery_address_address3: "",
          update_delivery_address_postcode: "",
          update_delivery_address_city: "",
          update_delivery_address_pays: "",
        };

        this.modeClinique = "simple";
        this.adresseCliniqueSelectionnee = null;
      },

      /*************************Ajout / Modification d'une adresse client****************************/
      GetPays() {
        getCountries()
          .then(res => {
            this.countries = res.data;
          })
          .catch(() => {});
      },

      toggleDropdownCountry() {
        this.isOpenCountry = !this.isOpenCountry;
      },

      selectCountry(country) {
        this.selectedCountry = country;
        this.clientadress.countryCode = country.code;
        this.isOpenCountry = false;
        this.searchCountry = "";
      },

      OpenAddNewAdressModal() {
        this.ResetFormClientAdress();
        this.selectedCountry = {};
        this.HasEdit = false;
        const modalElement = this.$refs.adressclient;
        const modalInstance = Modal.getOrCreateInstance(modalElement);
        modalInstance.show();
      },

      OpenModifAdressModal(adress) {
        this.clientadress = {
          id: adress.id,
          firstName: adress.firstName,
          lastName: adress.lastName,
          company: adress.company || "",
          street: adress.street,
          postcode: adress.postcode,
          city: adress.city,
          countryCode: adress.countryCode,
          email: adress.email || "",
          cellphone: adress.cellphone || "",
        };
        this.selectedCountry = this.countries.find(country => country.code === adress.countryCode) || {};
        this.HasEdit = true;
        const modalElement = this.$refs.adressclient;
        const modalInstance = Modal.getOrCreateInstance(modalElement);
        modalInstance.show();
      },

      AddNewAdressClient() {
        this.erroradressLastName = "";
        this.erroradressFirstName = "";
        this.erroradressStreet = "";
        this.erroradressCodePostal = "";
        this.erroradressVille = "";
        this.erroradressPays = "";
        this.canStoreClientadress = true;
        this.isLoadingClientadress = true;
        this.successadressMessage = "";
        this.erroradressEmail = "";
        this.erroradressCellphone = "";
        var spinner =
          '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Enregistrement en cours ...';
        $("#save-client-adress").html(spinner);
        this.CheckValidateClientAdress();
        if (this.canStoreClientadress) {
          CreateNewAdressClient(this.clientadress, this.userRole, this.selectedVetForDelegue?.id)
            .then(res => {
              if (res.data && res.data.id) {
                this.ResetFormClientAdress();
                this.fetchAddresses();
                this.successadressMessage = "Votre nouvelle adresse a été ajoutée avec succès";
                setTimeout(() => {
                  this.successadressMessage = "";
                }, 5000);
                $("#save-client-adress").text("Enregistrer");
                this.isLoadingClientadress = false;
                const modalElement = this.$refs.adressclient;
                const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
                modalInstance.hide();
              }
            })
            .catch(() => {
              this.isLoadingClientadress = false;
              $("#save-client-adress").text("Enregistrer");
            });
        }
      },

      ModifAdressClient() {
        this.erroradressLastName = "";
        this.erroradressFirstName = "";
        this.erroradressStreet = "";
        this.erroradressCodePostal = "";
        this.erroradressVille = "";
        this.erroradressPays = "";
        this.canStoreClientadress = true;
        this.isLoadingClientadress = true;
        this.successadressMessage = "";
        this.erroradressEmail = "";
        this.erroradressCellphone = "";
        var spinner =
          '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Modification en cours ...';
        $("#save-client-adress").html(spinner);
        this.CheckValidateClientAdress();
        if (this.canStoreClientadress) {
          UpdateAdressClient(this.clientadress)
            .then(res => {
              if (res.data && res.data.id) {
                this.ResetFormClientAdress();
                this.fetchAddresses();
                this.successadressMessage = "Votre adresse a été modifiée avec succès";
                setTimeout(() => {
                  this.successadressMessage = "";
                }, 5000);
                $("#save-client-adress").text("Modifier");
                this.isLoadingClientadress = false;
                const modalElement = this.$refs.adressclient;
                const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
                modalInstance.hide();
              }
            })
            .catch(() => {
              this.isLoadingClientadress = false;
              $("#save-client-adress").text("Modifier");
            });
        }
      },

      CheckValidateClientAdress() {
        if (this.clientadress.lastName == "") {
          this.erroradressLastName = "Le champ nom est obligatoire";
          this.canStoreClientadress = false;
        }
        if (this.clientadress.firstName == "") {
          this.erroradressFirstName = "Le champ prénom est obligatoire";
          this.canStoreClientadress = false;
        }
        if (this.clientadress.street == "") {
          this.erroradressStreet = "Le champ addresse est obligatoire";
          this.canStoreClientadress = false;
        }
        if (this.clientadress.postcode == "") {
          this.erroradressCodePostal = "Le champ Code postal est obligatoire";
          this.canStoreClientadress = false;
        }
        if (this.clientadress.city == "") {
          this.erroradressVille = "Le champ ville est obligatoire";
          this.canStoreClientadress = false;
        }
        if (this.clientadress.countryCode == "") {
          this.erroradressPays = "Le champ pays est obligatoire";
          this.canStoreClientadress = false;
        }

        if (this.clientadress.email == "") {
          this.erroradressEmail = "Le champ email est obligatoire";
          this.canStoreClientadress = false;
        } else if (!this.isValidEmail(this.clientadress.email)) {
          this.erroradressEmail = "Veuillez entrer un email valide";
          this.canStoreClientadress = false;
        }
        if (this.clientadress.cellphone == "") {
          this.erroradressCellphone = "Le champ téléphone est obligatoire";
          this.canStoreClientadress = false;
        } else if (!this.isValidPhoneNumber(this.clientadress.cellphone)) {
          this.erroradressCellphone = "Veuillez entrer un numéro de téléphone valide";
          this.canStoreClientadress = false;
        }

        if (!this.canStoreClientadress) {
          this.isLoadingClientadress = false;
          if (this.HasEdit) $("#save-client-adress").text("Modifier");
          else $("#save-client-adress").text("Enregistrer");
        }
      },

      isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
      },

      isValidPhoneNumber(phoneNumber) {
        const phoneRegex = /^\+?\d[\d\s-]{8,}$/;
        return phoneRegex.test(phoneNumber);
      },

      ResetFormClientAdress() {
        this.clientadress = {
          firstName: "",
          lastName: "",
          street: "",
          postcode: "",
          city: "",
          countryCode: "",
          email: "",
          cellphone: "",
        };
        this.erroradressLastName = "";
        this.erroradressFirstName = "";
        this.erroradressStreet = "";
        this.erroradressCodePostal = "";
        this.erroradressVille = "";
        this.erroradressPays = "";
        this.canStoreClientadress = true;
        this.isLoadingClientadress = false;
        this.successadressMessage = "";
        this.erroradressEmail = "";
        this.erroradressCellphone = "";
      },

      OpenRemoveAdressModal(adress_id) {
        this.adressToRemove = adress_id;
        const modalElement = this.$refs.RemoveAdress;
        const modalInstance = Modal.getOrCreateInstance(modalElement);
        modalInstance.show();
      },

      RemoveAdressClient() {
        this.successDeleteadressMessage = "";
        var spinner =
          '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Suppression en cours ...';
        $("#remove-adress").html(spinner);
        DeleteAdressClient(this.adressToRemove)
          .then(() => {
            this.successDeleteadressMessage = "Votre adresse a été supprimée avec succès";
            this.fetchAddresses();
            $("#remove-adress").text("Confirmer");
            setTimeout(() => {
              this.successDeleteadressMessage = "";
              const modalElement = this.$refs.RemoveAdress;
              const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
              modalInstance.hide();
            }, 3000);
          })
          .catch(() => {});
      },

      previousPage() {
        if (this.currentPage > 1) {
          this.currentPage--;
          window.scrollTo({ top: 20, behavior: "smooth" });
        }
      },

      nextPage() {
        if (this.currentPage < this.totalPages) {
          this.currentPage++;
          window.scrollTo({ top: 20, behavior: "smooth" });
        }
      },

      goToPage(page) {
        this.currentPage = page;
        window.scrollTo({ top: 20, behavior: "smooth" });
      },
    },
  };
</script>
<style scoped>
  @media (max-width: 767px) {
    /* En-têtes et titres */
    .d-flex.align-items-center.justify-content-between {
      flex-direction: column !important;
      align-items: flex-start !important;
      gap: 1rem;
    }

    h3 {
      font-size: 1.25rem;
      line-height: 1.4;
    }

    .d-flex.justify-content-between.w-100.mb-4 {
      flex-direction: column !important;
      align-items: stretch !important;
      gap: 1rem;
    }

    .left-adress-item {
      width: 100% !important;
      flex-direction: column !important;
    }

    .search-block {
      width: 100% !important;
      margin-bottom: 0.5rem;
    }

    .right-adress-item {
      width: 100%;
      display: flex;
      justify-content: center;
    }

    .right-adress-item .btn {
      width: 100%;
      justify-content: center;
      order: 1; /* S'assure que le bouton vient après la recherche */
    }

    /* Items d'adresse */
    .adress-item {
      flex-direction: column !important;
      align-items: flex-start !important;
      padding: 1rem 0.75rem;
      gap: 0.75rem;
      border-bottom: 1px solid #dee2e6;
    }

    .adress-item:last-child {
      border-bottom: none;
    }

    .adress-item p {
      word-break: break-word;
      font-size: 0.9rem;
      line-height: 1.4;
    }

    .adress-item .d-flex.gap-2 {
      width: 100%;
      justify-content: flex-end;
    }

    /* Boutons circulaires */
    .btn-circle {
      width: 40px;
      height: 40px;
      min-width: 40px;
    }

    /* Pagination mobile */
    .pagination {
      flex-direction: column;
      gap: 0.5rem;
      padding: 1rem 0;
    }

    .pagination-content {
      order: 2;
    }

    .pagination-btn.prev {
      order: 1;
    }

    .pagination-btn.next {
      order: 3;
    }

    .pagination-btns {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 0.25rem;
    }

    .pagination-btns button {
      min-width: 36px;
      height: 36px;
      font-size: 0.9rem;
    }

    /* Formulaires */
    .form-block .row > div[class*="col-"] {
      margin-bottom: 1rem;
    }

    .modal-dialog {
      margin: 0.5rem;
    }

    .modal-width {
      max-width: 95vw !important;
    }

    /* Checkboxes */
    .d-flex.gap-4 {
      flex-direction: column !important;
      gap: 0.75rem !important;
    }

    /* Alerte suppression clinique */
    .alert.alert-warning {
      font-size: 0.875rem;
      padding: 0.75rem;
    }
  }

  /* Optimisations pour petits mobiles (< 480px) */
  @media (max-width: 479px) {
    .content-dashboard {
      padding: 0.75rem;
    }

    h3 {
      font-size: 1.1rem;
    }

    .btn {
      font-size: 0.875rem;
      padding: 0.5rem 1rem;
    }

    .form-control {
      font-size: 0.9rem;
      height: 40px;
    }

    .adress-item p {
      font-size: 0.85rem;
    }

    /* Bouton ajouter une adresse */
    .right-adress-item .btn {
      font-size: 0.85rem;
      padding: 0.625rem;
    }

    .icon-plus {
      width: 16px;
      height: 16px;
      margin-right: 0.25rem;
    }
  }

  /* Zone tactile améliorée pour mobile */
  @media (hover: none) and (pointer: coarse) {
    .btn,
    a[href],
    button {
      min-height: 44px;
      min-width: 44px;
    }

    .btn-circle {
      min-width: 48px !important;
      min-height: 48px !important;
    }

    /* Pour les champs de recherche */
    .search-block input {
      min-height: 48px;
    }

    .search-btn {
      min-height: 48px;
      min-width: 48px;
    }
  }

  /* Pour les tablettes (768px - 1024px) */
  @media (min-width: 768px) and (max-width: 1024px) {
    .left-adress-item {
      flex-wrap: wrap;
    }

    .search-block {
      width: 100% !important;
      margin-bottom: 1rem;
    }

    .right-adress-item {
      width: 100%;
    }

    .right-adress-item .btn {
      width: 100%;
      justify-content: center;
    }
  }

  /* Animation pour le bouton de recherche */
  .search-block form {
    position: relative;
    display: flex;
  }

  .search-block input {
    padding-right: 50px;
  }

  .search-btn {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    background: transparent;
    border: none;
    padding: 0 15px;
    color: #6c757d;
  }

  .search-btn:hover {
    color: #495057;
  }
</style>
